import { Suspense } from "react"
import ReactDOM from "react-dom/client"
import { ThemeProvider } from "@mui/material/styles"
import theme from "@/theme"
import { Provider } from "react-redux"
import { HashRouter } from "react-router-dom"
import App from "./App"
import { store } from "@app/store"
import "./index.css"
import { YandexMapProvider } from "@common/yandex/provider/YandexMapProvider"
import { GoogleOAuthProvider } from "@react-oauth/google"
import { Compose } from "./utils/compose.utils";

const clientId = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID
import { CssBaseline } from "@mui/material"
import globalScrollbarStyles from "@/theme/globalScrollbarStyles"
import ErrorPopup from "@components/ErrorPopup"
import { YandexOAuthConsumer } from "@/app/data/oauth2/YandexOAuth2Provider"

const AppProviders = () => {
  const providersWithProps = [
    (props: any) => <Provider store={store} {...props} />,
    (props: any) => <YandexOAuthConsumer {...props} />,
    (props: any) => <HashRouter {...props} />,
    (props: any) => <YandexMapProvider {...props} />,
    (props: any) => <GoogleOAuthProvider clientId={clientId} {...props} />,
    (props: any) => <ThemeProvider theme={theme} {...props} />
  ];

  return (
    <Compose components={providersWithProps}>
      <CssBaseline />
      {globalScrollbarStyles}
      <Suspense fallback={<div>Загрузка...</div>}>
        <App />
      </Suspense>
      <ErrorPopup />
    </Compose>
  )
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AppProviders />
)
